module.exports = __webpack_public_path__ + "media/images/emblems/Vionnaz-e0beba48af78100a44238b490c6dc083.png";